import axios from 'axios';

export function isHttpAbortError(error) {
    if (!error) return false;
    const code = error?.code;
    if (code === 'ERR_CANCELED' || code === 'ECONNABORTED' && error?.message?.includes?.('canceled')) return true;
    if (error?.name === 'CanceledError' || error?.name === 'AbortError') return true;
    if (typeof axios.isCancel === 'function' && axios.isCancel(error)) return true;
    return false;
}

/**
 * Maps transport aborts (pool recovery, tab wake) to a user-visible save/load failure message.
 */
export function toUserFacingHttpError(error) {
    if (isHttpAbortError(error)) {
        const err = new Error('Connection was reset. Your changes may not have been saved — please try again.');
        err.code = 'ERR_CANCELED';
        err.cause = error;
        return err;
    }
    return error;
}
